import React from 'react'
import {
    BackButton,
    BlocIntField,
    Button,
    Conditionnal,
    Header,
    ProgressBar,
} from '../ImportAll'

export default function Vue13() {
    return (
        <div>
            <Header
                title="J'estime mon prêt"
                subTitle="Quel est votre apport personnel ? "
            />
            <div className="Container">
                <div className="BackNavigationContainerLeft">
                    <BackButton />
                </div>
            </div>
            <div className="Container">
                <ProgressBar size={90} time={1} />
            </div>

            <div className="Container">
                <Conditionnal
                    linked_data_id="prj_maturite"
                    isEqualTo
                    targetDataValueCompare="TROUVE"
                >
                    <BlocIntField
                        key="key114"
                        nbcolumn={1}
                        linked_data_id="finance_apport"
                        symbole=" €"
                        informationApport
                        label="Montant de l’apport"
                        placeholder="Ex : 42 000 €"
                        infobulle="Le niveau d’apport constitue un atout pour votre dossier. Il est recommandé qu'il couvre à minima les frais de notaire. A noter, plus l'apport sera important meilleur pourra être votre taux"
                    />
                </Conditionnal>

                <Conditionnal
                    linked_data_id="prj_maturite"
                    isNotEqualTo
                    targetDataValueCompare="TROUVE"
                >
                    <BlocIntField
                        key="key114"
                        nbcolumn={1}
                        linked_data_id="finance_apport"
                        symbole=" €"
                        label="Montant de l’apport"
                        placeholder="Ex : 42 000 €"
                        infobulle="Le niveau d’apport constitue un atout pour votre dossier. Il est recommandé qu'il couvre à minima les frais de notaire. A noter, plus l'apport sera important meilleur pourra être votre taux"
                    />
                </Conditionnal>

                <BlocIntField
                    key="key115"
                    nbcolumn={1}
                    linked_data_id="finance_epargne_apres_apport"
                    symbole=" €"
                    label="Montant de l’épargne après apport"
                    placeholder="Ex : 42 000 €"
                />
            </div>

            <Conditionnal
                linked_data_id="tech_source_neuf"
                isEqualTo
                targetDataValueCompare={true}
            >
                <Conditionnal
                    linked_data_id="prj_usage"
                    isEqualTo
                    targetDataValueCompare="LOCATIF"
                >
                    <div className="SubmitButtonContainer">
                        {' '}
                        <Button
                            text="Suivant"
                            targetView={16}
                            forcerDureeCredit={240}
                        />{' '}
                    </div>
                </Conditionnal>
                <Conditionnal
                    linked_data_id="prj_usage"
                    isNotEqualTo
                    targetDataValueCompare="LOCATIF"
                >
                    <div className="SubmitButtonContainer">
                        {' '}
                        <Button
                            text="Suivant"
                            targetView={16}
                            forcerDureeCredit={300}
                        />{' '}
                    </div>
                </Conditionnal>
            </Conditionnal>
            <Conditionnal
                linked_data_id="tech_source_neuf"
                isNotEqualTo
                targetDataValueCompare={true}
            >
                <div className="SubmitButtonContainer">
                    {' '}
                    <Button text="Suivant" targetView={14} />{' '}
                </div>
            </Conditionnal>
        </div>
    )
}
